import { createColumnHelper } from '@tanstack/react-table'

import type { ColumnSort } from '@tanstack/react-table'
import type { TreatmentProcedureChangeLogType } from 'types/changeLog'

import { defaultColumnOptions } from 'utils/table'
import { getName } from 'utils/text'
import { format, APPOINTMENT_FORMAT } from 'utils/time'

export const changeLogDefaultSortees: ColumnSort[] = [
  { id: 'ModifiedAt', desc: true },
]

const columnHelper = createColumnHelper<TreatmentProcedureChangeLogType>()

export const changeLogColumns = () => [
  columnHelper.accessor(
    row => row.treatmentProcedure?.procedure?.name ?? '--',
    {
      ...defaultColumnOptions<TreatmentProcedureChangeLogType>(),
      id: 'procedure',
      header: 'Procedure',
      enableColumnFilter: false,
    },
  ),
  columnHelper.accessor('modifiedField', {
    ...defaultColumnOptions<TreatmentProcedureChangeLogType>(),
    header: 'Field Changed',
    id: 'modifiedField',
    enableColumnFilter: false,
  }),
  columnHelper.accessor('oldValue', {
    ...defaultColumnOptions<TreatmentProcedureChangeLogType>(),
    header: 'Old Value',
    enableColumnFilter: false,
    enableSorting: false,
    cell: ({ row: { original } }) => original.oldValue ?? '--',
  }),
  columnHelper.accessor('newValue', {
    ...defaultColumnOptions<TreatmentProcedureChangeLogType>(),
    header: 'New Value',
    enableColumnFilter: false,
    enableSorting: false,
    cell: ({ row: { original } }) => original.newValue ?? '--',
  }),
  columnHelper.accessor('actionType', {
    ...defaultColumnOptions<TreatmentProcedureChangeLogType>(),
    header: 'Action Type',
    enableColumnFilter: false,
  }),
  columnHelper.accessor('actionSource', {
    ...defaultColumnOptions<TreatmentProcedureChangeLogType>(),
    header: 'Action Source',
    enableColumnFilter: false,
  }),
  columnHelper.accessor(row => getName(row.modifiedBy), {
    ...defaultColumnOptions<TreatmentProcedureChangeLogType>(),
    id: 'modifiedBy',
    header: 'Modified By',
    enableColumnFilter: false,
  }),
  columnHelper.accessor('modifiedAt', {
    ...defaultColumnOptions<TreatmentProcedureChangeLogType>(),
    header: 'Modified At',
    id: 'modifiedAt',
    enableColumnFilter: false,
    cell: ({ row: { original } }) =>
      (original.modifiedAt
        ? format(new Date(original.modifiedAt), APPOINTMENT_FORMAT)
        : '--'),
  }),
]
